import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "@emotion/styled";
import { db } from "../../firebase.js";
import { doc, getDoc } from "firebase/firestore";
import { colors } from "../../utils/colors.js";
import { ReactComponent as Ring } from "../../assets/icons/Ring.svg";
import dayjs from "dayjs";
import Hebcal from "hebcal";
import CustomSwitch from "../../components/CustomSwitch.js";
import Swal from "sweetalert2";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  // justify-content: flex-start;
  margin-top: 36px;
  max-width: 1040px;
  direction: rtl;
  width: 100vw;
  overflow: hidden;
  padding-top: 40px;
  padding-bottom: 40px;
  margin-top: 0;
`;
export const InvTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 16px;
  font-family: Rubik;
  font-size: calc(16px + 3vmin);
  line-height: normal;

  font-style: normal;
  font-weight: 700;
  padding: 0 20px;
`;
export const InvLogoContainer = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-content: center;
  align-items: center;
`;
export const InvLogo = styled.img`
  height: auto;
  padding-bottom: 40px;
  margin-bottom: 16px;
  // width: 70vw;
  display: flex;

  @media (max-width: 920px) {
    width: 75vw;
  }
  @media (max-width: 550px) {
    width: 100vw;
  }
`;

const BadgesContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  height: 80px;
  gap: 24px;
  position: absolute;
  bottom: 5px;
`;
const Badge = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  min-height: 79px;
  min-width: 65px;
  max-height: 79px;
  max-width: 65px;
  box-shadow: 0px 2px 8px 0px rgba(122, 0, 57, 0.3);
  border-radius: 8px;

  text-shadow: 0px 2px 8px rgba(122, 0, 57, 0.3);
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #ffffff;
`;

const BadgeHourLabel = styled.span`
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: #ffffff;
`;

const IntroTextLabel = styled.span`
  margin-top: 8px;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: "#202020";
  width: 50vw;
  padding: 0 20px;

  @media (max-width: 920px) {
    width: 75vw;
  }
  @media (max-width: 550px) {
    width: 97vw;
  }
`;
const VerbalDateLabel = styled.span`
  text-align: center;
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: "#202020";
  margin-top: 8px;
  padding: 0 20px;
`;
const FormatDateLabel = styled.span`
  text-align: center;
  font-family: Rubik;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: "#202020";
  padding: 0 20px;
`;
const AddToCalendarLabel = styled.span`
  margin-top: 4px;

  text-align: center;
  font-family: Rubik;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #1e0f9a;
  padding: 0 20px;
`;
const LocationLabel = styled.span`
  margin-top: 8px;

  text-align: center;
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: "#202020";
  padding: 0 20px;
`;

const NavigateWithWazeBtn = styled.div`
  border-radius: 16px;
  color: #05c8f7;
  box-shadow: 0px 2px 8px 0px rgba(122, 0, 57, 0.3);
  width: 170px;
  height: 19px;
  padding: 8px 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  cursor: pointer;

  //label
  color: #fff;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const GuestStatusBtnsContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 50vw;

  margin-top: 16px;
  padding: 10px;
  gap: 10px;

  @media (max-width: 920px) {
    width: 75vw;
  }
  @media (max-width: 550px) {
    width: 97vw;
  }
`;

const GuestStatusBtn = styled.div`
  border-radius: 16px;
  box-shadow: 0px 2px 8px 0px rgba(122, 0, 57, 0.3);
  flex: 1;
  padding: 10px;
  height: 19px;

  //label
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
`;
const SwitchRow = styled.div`
  width: 50vw;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;

  //label
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #202020;

  @media (max-width: 920px) {
    width: 75vw;
  }
  @media (max-width: 550px) {
    width: 97vw;
  }
`;

function InvitationPreview() {
  let { invitationId } = useParams();
  const [invitation, setInvitation] = useState({});

  function getHebrewDayOfWeek(dayOfWeek) {
    // Convert the day of the week to its corresponding Hebrew name
    const hebrewDaysOfWeek = [
      "שבת",
      "ראשון",
      "שני",
      "שלישי",
      "רביעי",
      "חמישי",
      "שישי",
    ];
    return hebrewDaysOfWeek[dayOfWeek];
  }

  const getHebrewDate = (date) => {
    const hebcalDate = new Hebcal.HDate(date);

    // Extract the Hebrew date components
    // const hebrewYear = hebcalDate.year;
    const hebrewMonth = hebcalDate.toString("h");
    // const hebrewDay = hebcalDate.day;
    const hebrewDayOfWeek = getHebrewDayOfWeek(hebcalDate.getDay());

    return `יום ${hebrewDayOfWeek}, ${hebrewMonth?.replace(" ", " ב")}`;
  };

  const [guest, setGuest] = useState({
    needRide: false,
    kosherFood: false,
    isHealthy: false,
  });

  useEffect(() => {
    //get event details
    const docInvRef = doc(db, "invitations", invitationId);
    getDoc(docInvRef)
      .then((docSnap) => {
        const eventData = docSnap.data();
        const eventDate = new Date(eventData.eventDate.toDate());

        setInvitation({ ...eventData, eventDate: dayjs(eventDate) });
      })
      .catch((e) => {
        console.error(e?.message);
      });
  }, [invitationId]);

  const handleRSVP = async (status) => {
    Swal.fire({
      position: "top-center",
      icon: "error", //success || error
      title: "זוהי תצוגה מקדימה",
      showConfirmButton: false,
      timer: 1500,
    });
  };

  const handleWazeClick = () => {
    Swal.fire({
      position: "top-center",
      icon: "error", //success || error
      title: "זוהי תצוגה מקדימה",
      showConfirmButton: false,
      timer: 1500,
    });
  };

  return (
    <Container
      style={{
        borderStyle: "solid",
        borderWidth: 5,
        borderColor: colors[invitation?.invitationColor],
      }}
    >
      <Ring
        style={{
          width: "15%",
          minWidth: 50,
          fill: colors[invitation?.invitationColor],
          marginBottom: 8,
        }}
      />
      <InvTitle
        style={{
          color: colors[invitation?.invitationColor],
        }}
      >
        {invitation?.title}
      </InvTitle>
      <InvLogoContainer>
        <InvLogo src={invitation?.imageUrl} />
        <BadgesContainer>
          <Badge
            style={{
              backgroundColor: colors[invitation?.invitationColor],
            }}
          >
            קבלת פנים
            <BadgeHourLabel>{invitation?.receptionTime}</BadgeHourLabel>
          </Badge>
          <Badge
            style={{
              backgroundColor: colors[invitation?.invitationColor],
            }}
          >
            {invitation?.huppaDescription}
            <BadgeHourLabel>{invitation?.huppaTime}</BadgeHourLabel>
          </Badge>
          <Badge
            style={{
              backgroundColor: colors[invitation?.invitationColor],
            }}
          >
            {invitation?.dancingDescription}
            <BadgeHourLabel>{invitation?.dancingTime}</BadgeHourLabel>
          </Badge>
        </BadgesContainer>
      </InvLogoContainer>
      <IntroTextLabel>{invitation?.description}</IntroTextLabel>
      <VerbalDateLabel>
        {getHebrewDate(new Date(invitation?.eventDate))}
      </VerbalDateLabel>
      <FormatDateLabel
        style={{
          color: colors[invitation?.invitationColor],
        }}
      >
        {dayjs(invitation?.eventDate).format("DD/MM/YYYY")}
      </FormatDateLabel>
      <AddToCalendarLabel>SAVE THE DATE</AddToCalendarLabel>
      <LocationLabel>{invitation.eventAddress}</LocationLabel>
      <NavigateWithWazeBtn
        onClick={handleWazeClick}
        style={{
          backgroundColor: colors.waze,
        }}
      >
        ניווט באמצעות Waze
      </NavigateWithWazeBtn>
      <GuestStatusBtnsContainer>
        <GuestStatusBtn
          onClick={() => handleRSVP("approved")}
          style={{
            backgroundColor: colors.approve,
            color: "#ffffff",
          }}
        >
          מגיעים
        </GuestStatusBtn>
        <GuestStatusBtn
          onClick={() => handleRSVP("maybe")}
          style={{
            backgroundColor: colors.maybe,
            color: "#000000",
          }}
        >
          אולי מגיעים
        </GuestStatusBtn>
        <GuestStatusBtn
          onClick={() => handleRSVP("rejected")}
          style={{
            backgroundColor: colors.reject,
            color: "#ffffff",
          }}
        >
          לא מגיעים
        </GuestStatusBtn>
      </GuestStatusBtnsContainer>
      {invitation?.shouldAskForRide && (
        <SwitchRow>
          צריכים הסעה?
          <CustomSwitch
            checked={guest?.needRide}
            onChange={() =>
              setGuest((oldGuest) => ({
                ...oldGuest,
                needRide: !oldGuest.needRide,
              }))
            }
          />
        </SwitchRow>
      )}
      {invitation?.shouldAskForDishPreference && (
        <SwitchRow>
          צמחוניים / טבעוניים / אלרגיה לגלוטן?
          <CustomSwitch
            checked={guest?.kosherFood}
            onChange={() =>
              setGuest((oldGuest) => ({
                ...oldGuest,
                kosherFood: !oldGuest.kosherFood,
              }))
            }
          />
        </SwitchRow>
      )}
      {invitation?.shouldAskForHealthStatement && (
        <SwitchRow>
          אנו מצהירים כי אין לנו כל בעיה רפואית המונעת הגעה לאירוע
          <CustomSwitch
            checked={guest?.isHealthy}
            onChange={() =>
              setGuest((oldGuest) => ({
                ...oldGuest,
                isHealthy: !oldGuest?.isHealthy,
              }))
            }
          />
        </SwitchRow>
      )}
    </Container>
  );
}

export default InvitationPreview;
